import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { TODIS_PRIMARY_BTN, TODIS_OUTLINE_BTN_R, TODIS_PRIMARY_SUBMIT_BTN } from "../../components/Buttons";
import arrow from "../../assets/icons/arrow-white.svg";
import arrowDark from "../../assets/icons/arrow-dark.svg";
import { TODIS_FORM_TEXT, TODIS_FORM_PASS } from "../../components/Forms";
import useAuth from "../../auth/authProvider";
import { useState } from "react";
import { BsArrowRight, BsCheckCircle } from 'react-icons/bs'; 
import { Link } from "react-router-dom";
import Swal from 'sweetalert2'

const TODIS_SIGN_IN_FORM = () => {


    const { state, logout, login } = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");


    //handle username
    const handleUsernameChange = (event) => {
        setUsername(event.target.value);
    }

    //handel password
    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
    }



    //sign in here...   
    const handleSubmit = event => {
        event.preventDefault();
        //console.log("handle submit is called..", state.isLoggedIn);
    
    
        // Mostrar Swal de carga después de 1 segundo
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we process your request.',
                allowOutsideClick: false,
                //showCancelButton: true,
                //cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }, 500);
    
        login(username, password).then(() => {
            // Cerrar Swal de carga si se muestra
            clearTimeout(loadingSwalTimeout);
            Swal.close();
        }).catch(error => {
            // Manejar errores y cerrar Swal de carga si se muestra
            clearTimeout(loadingSwalTimeout);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error occurred while processing your request. Please wait until your first request is executed.",
                showConfirmButton: true
            });
        });
    
        // logout()
        //console.log("handle submit is called..", state.isLoggedIn);
    };

    return (
        <Container fluid className="todis-sign-in-form-wrapper">
            <h2 className="text-center todis-header mb-5">Sign In to Transport Community Portal</h2>

            <Form className="mt-5" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    {/* <Form.Label>Email address</Form.Label> */}
                    {/* <TODIS_FORM_TEXT placeholder="USERNAME" /> */}
                    <Form.Control type="text" placeholder="USERNAME" style={text_styles} className="todis-forms" onChange={handleUsernameChange} value={username} />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    {/* <Form.Label>Password</Form.Label> */}
                    {/* <TODIS_FORM_PASS placeholder="PASSWORD" /> */}
                    <Form.Control type="password" placeholder="PASSWORD" style={text_styles} className="todis-forms" onChange={handlePasswordChange} value={password} />
                </Form.Group>
                {state.loginError != null ?
                    <div>
                        <h5 style={{ color: "red", textAlign: "center" }}>Invalid Credentials</h5>
                    </div> : null
                }

                <Row className="mb-3">
                    {/* <Form.Group as={Col} className="" controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="REMEMBER ME" className="todis-form-checkbox" />
                    </Form.Group> */}
                    <Col className="text-right"><a href="/TODIS-APP/ResetPassword" className="todis-forgot-pass">FORGOT PASSWORD?</a></Col>
                </Row>
                <Row className="mt-5 d-flex justify-content-center">
                    {/*<Col xs={12} md={6} className="p-2"><TODIS_OUTLINE_BTN_R title="Continue as a guest" image={arrowDark} /></Col>*/}
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="p-2">
                        <TODIS_PRIMARY_SUBMIT_BTN
                            title="Sign In"
                            type="submit"
                            icon={<BsArrowRight size={15} className="todis-icon-btn" />}
                        />
                    </Col>
                </Row>
            </Form>

        </Container>
    )
}

export default TODIS_SIGN_IN_FORM;

// style={{border: '1px solid #FFC61C', padding: '0.75rem', borderRadius: '9px',backgroundColor: 'transparent'}}

const text_styles = {
    borderRadius: '19px',
    padding: '1rem',
    marginTop: '2rem',
    border: '0px',
    color: '#0B4CA1'
}